import { NgModule } from '@angular/core';
import { DscHeaderComponent } from './dsc-header.component';
import { CommonModule } from '@angular/common';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ClarityModule } from "@clr/angular";
import { DscCollapsibleListModule } from "dsc-collapsible-list";

@NgModule({
  declarations: [DscHeaderComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    DscCollapsibleListModule,
    ClarityModule,
  ],
  exports: [DscHeaderComponent]
})
export class DscHeaderModule { }
